import { baseStrapiURL } from './config';

/**
 * Service pour gérer les appels API liés à l'ebook
 */
class EbookService {
    /**
     * Enregistrer un utilisateur pour le téléchargement d'ebook
     * @param {Object} userData - Données utilisateur
     * @param {string} userData.email - Email de l'utilisateur
     * @param {string} userData.prenom - Prénom de l'utilisateur
     * @param {string} userData.codePostal - Code postal de l'utilisateur
     * @param {string} userData.recaptchaToken - Token reCAPTCHA
     * @param {string} downloadLink - Lien de téléchargement
     * @returns {Promise<Object>} Réponse de l'API
     */
    async registerForEbook(userData, downloadLink) {
        try {
            
            const response = await fetch(`${baseStrapiURL}/api/ebook/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: userData.email,
                    prenom: userData.prenom,
                    codePostal: userData.codePostal,
                    recaptchaToken: userData.recaptchaToken,
                    downloadLink: downloadLink
                })
            });
            
            const responseData = await response.json();
            
            if (!response.ok) {
                console.error('Erreur API ebook:', responseData);
                throw new Error(responseData.error?.message || 'Erreur lors de l\'enregistrement');
            }
            
            return responseData;
            
        } catch (error) {
            console.error('Erreur service ebook:', error);
            throw error;
        }
    }
}

// Export d'une instance unique
export const ebookService = new EbookService();
export default ebookService;